{
  "de": {
    "wordClouds": {
      "buttons": {
        "addWord": "Wort hinzufügen"
      },
      "headers": {
        "options": "Optionen",
        "wordCloud": "Wortwolke"
      },
      "labels": {
        "show": "Wortwolke anzeigen",
        "showBeforeSubmit": "Wortwolke sichtbar vor Worteingabe",
        "visitorCanWrite": "Besucher*in kann Worte hinzufügen",
        "wordOccurences": "Wörter mit Häufigkeit",
        "words": "Wörter (je Wort eine Zeile)"
      },
      "links": {
        "save": "Wortwolke als Bild speichern"
      },
      "placeholders": {
        "addWord": "Wort hinzufügen..."
      }
    }
  }
}
